import { render } from "./InviteModal.vue?vue&type=template&id=6ba1a8cb&scoped=true"
import script from "./InviteModal.vue?vue&type=script&lang=js"
export * from "./InviteModal.vue?vue&type=script&lang=js"

import "./InviteModal.vue?vue&type=style&index=0&id=6ba1a8cb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba1a8cb"]])

export default __exports__